import React, { useState } from 'react';
import styled from 'styled-components';
import { RandomReveal } from 'react-random-reveal';
import { Button, Input, Label, Option, Select } from 'styles';
import { design } from 'utils';

const SectionWrap = styled.div`
  text-align: center;
  margin: ${design.spacing[4]} 0;
`;
const ButtonWrap = styled(SectionWrap)`
  display: flex;
  justify-content: center;
  button {
    margin: 0 ${design.spacing[4]};
  }
`;
const InputWrapper = styled.div`
  margin-bottom: ${design.spacing[1]};
`;
const InputMargin = styled(Input)`
  margin-left: ${design.spacing[1]};
`;
const OrderWrap = styled.dl`
  font-size: ${design.fontSizes[3]};
  margin: auto;
  max-width: 40%;
  text-align: left;
  div {
    display: grid;
    grid-template-columns: 20% 80%;
    border-bottom: 1px solid ${design.colors.secondary};
    &:first-child {
      border-top: 1px solid ${design.colors.secondary};
    }
    &:nth-child(2n + 1) {
      background-color: ${design.colors.tertiary};
    }
  }
  dt,
  dd {
    margin: 0;
    padding: ${design.spacing[1]} ${design.spacing[2]};
  }
`;

const AdminDraftOrder = () => {
  const [draftOrder, setDraftOrder] = useState([]);
  const [isResetting, setIsResetting] = useState(false);
  const [numberOfTeams, setNumberOfTeams] = useState(0);
  const [teams, setTeams] = useState({});

  const handleSetTeams = (index) => (e) => {
    const teamsList = { ...teams };
    teamsList[index] = e.target.value;
    setTeams(teamsList);
  };

  const handleSetOrder = () => {
    let array = Object.values(teams);
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    setDraftOrder(array);
  };

  const handleReset = () => {
    setIsResetting(true);
    setDraftOrder([]);
    setTimeout(() => {
      handleSetOrder();
      setIsResetting(false);
    }, 20);
  };

  const resetFields = () => {
    setDraftOrder([]);
    setNumberOfTeams(0);
    setTeams({});
  };

  const randomizedCharacters = draftOrder.join('').split('');

  return (
    <main>
      <h1>Draft Order</h1>
      {draftOrder.length === 0 || isResetting ? (
        <>
          <SectionWrap>
            <Label htmlFor="numTeams">
              Number of Teams:
              <Select
                data-int
                defaultValue={0}
                id="numTeams"
                onChange={(e) => setNumberOfTeams(e.target.value)}
                required
              >
                <Option value={0} disabled>
                  Select a Number
                </Option>
                {Array.from({ length: 8 }, (_, index) => index).map((i) => (
                  <Option value={Number(i + 1)} key={i}>
                    {i + 1}
                  </Option>
                ))}
              </Select>
            </Label>
          </SectionWrap>
          {numberOfTeams > 0 && (
            <>
              <SectionWrap>
                {Array.from({ length: numberOfTeams }, (_, index) => (
                  <InputWrapper key={index}>
                    <Label htmlFor={`teamName-${index}`}>
                      Team {index + 1}:
                      <InputMargin
                        onChange={handleSetTeams(index)}
                        value={teams[index]}
                      />
                    </Label>
                  </InputWrapper>
                ))}
              </SectionWrap>
              <SectionWrap>
                <Button
                  onClick={handleSetOrder}
                  disabled={
                    Object.values(teams).length !== Number(numberOfTeams)
                  }
                >
                  Generate Draft Order
                </Button>
              </SectionWrap>
            </>
          )}
        </>
      ) : (
        <>
          <SectionWrap>
            <OrderWrap>
              {draftOrder.map((team, i) => {
                const duration = draftOrder.length - i;
                return (
                  <div key={team}>
                    <dt>{i + 1}</dt>
                    <dd>
                      <RandomReveal
                        characters={team}
                        characterSet={randomizedCharacters}
                        duration={duration}
                        isPlaying
                        revealDuration={0}
                      />
                    </dd>
                  </div>
                );
              })}
            </OrderWrap>
          </SectionWrap>
          <ButtonWrap>
            <Button onClick={handleReset}>Re-Roll Order</Button>
            <Button invert onClick={resetFields}>
              Reset Fields
            </Button>
          </ButtonWrap>
        </>
      )}
    </main>
  );
};

export default AdminDraftOrder;
